import { useEffect, useState } from 'react';

type Props = {
  speed?: number;
  renderInvisible?: boolean;
};

export const ProgressDots = ({
  speed = 300,
  renderInvisible = false,
}: Props) => {
  const [dots, setDots] = useState<string>('');

  useEffect(() => {
    const id = setInterval(() => {
      setDots((current) => {
        if (current.length === 3) {
          return '';
        }
        return `${current}.`;
      });
    }, speed);
    return () => clearInterval(id);
  }, [speed]);

  if (renderInvisible) {
    return (
      <>
        <span style={{ visibility: dots.length ? 'visible' : 'hidden' }}>
          .
        </span>
        <span style={{ visibility: dots.length >= 2 ? 'visible' : 'hidden' }}>
          .
        </span>
        <span style={{ visibility: dots.length >= 3 ? 'visible' : 'hidden' }}>
          .
        </span>
      </>
    );
  }

  return <>{dots}</>;
};
